export enum OverlayMode {
  OUTER = 'outer',
  INNER = 'inner',
}
